var exports = {
  "Vc": "x620889e6--a3f1dd--form-footer",
  "yn": "x620889e6--a3f1dd--privacy-policy-container",
  "zm": "x620889e6--a3f1dd--privacy-policy-link",
  "oQ": "x620889e6--a3f1dd--submit-button-container",
};

module.exports = exports;
